import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { Button } from "primereact/button";
import { StatusApi } from "../../../../../app/apiSlice";

interface ISynchroniseNifiButton {
    status:StatusApi
    NifiSynchronization: ()=> void,
}

//Button used to launch synchronisation with Nifi (Sources or Domaines)
const SynchroniseNifiButton = ({status,NifiSynchronization}:ISynchroniseNifiButton) => {
        if (status.isLoading)
          return (
            <Button
              className="p-button-rounded p-button-secondary p-button-outlined"
              disabled={true}
            >
              <div className="is__loading">
                <FontAwesomeIcon icon="spinner" spin /> {t("label.loading")}
              </div>
            </Button>
          );
        if (status.isError)
          return (
            <Button className="p-button-rounded p-button-secondary p-button-outlined">
              <div
                className="is__error"
                onClick={() => {
                    NifiSynchronization();
                }}
              >
                <FontAwesomeIcon icon="sync" /> {t("label.error")} !
              </div>
            </Button>
          );
    
        return (
          <Button
            className="p-button-rounded p-button-secondary p-button-outlined"
            onClick={() =>
                NifiSynchronization()
            }
          >
            <div>
              <FontAwesomeIcon icon="play" />
              &nbsp;{"Synchroniser"}
            </div>
          </Button>
        );
      
}


export default SynchroniseNifiButton;